import api from "../api.js";

export const submitFeedback = async (data) => {
  const response = await api.post("/feedback", data);
  return response.data;
};

export const getApprovedFeedbacks = async () => {
  const response = await api.get("/feedback");
  return response.data;
};